// Batch 27 · Add-on 3 · C (M41) — "A new version of AZEX is available — Reload" (EN / AR). Shown when the server's build id
// differs from this tab's; the page never reloads by itself, and a click with unsaved changes asks first.
import React, { useCallback, useEffect, useState } from "react";
import { useI18n } from "@/contexts/I18nContext";
import { newVersionAvailable, CHECK_EVERY_MS, API_404_EVENT } from "@/lib/buildCheck";
import { hasUnsaved } from "@/lib/unsavedChanges";
import { askConfirm } from "@/lib/appDialog";

export const NV_TEXT = {
  en: { msg: "A new version of AZEX is available —", reload: "Reload", unsaved: "This screen has unsaved changes. Reload anyway? The changes will be lost." },
  ar: { msg: "يتوفر إصدار جديد من AZEX —", reload: "إعادة التحميل", unsaved: "في هذه الشاشة تغييرات غير محفوظة. هل تريد إعادة التحميل؟ ستُفقد التغييرات." },
};

export default function NewVersionBanner({ check = newVersionAvailable, reload = () => window.location.reload(), everyMs = CHECK_EVERY_MS }) {
  const { lang } = useI18n();
  const L = NV_TEXT[lang === "ar" ? "ar" : "en"];
  const [available, setAvailable] = useState(false);
  const run = useCallback(async () => {
    try { const v = await check(); if (v === true) setAvailable(true); } catch { /* never in the way */ }
  }, [check]);
  useEffect(() => {
    run();
    const onFocus = () => run();
    window.addEventListener("focus", onFocus);
    window.addEventListener(API_404_EVENT, onFocus);
    const timer = setInterval(run, everyMs);
    return () => { window.removeEventListener("focus", onFocus); window.removeEventListener(API_404_EVENT, onFocus); clearInterval(timer); };
  }, [run, everyMs]);
  if (!available) return null;
  const onReload = async () => {
    if (hasUnsaved() && !(await askConfirm(L.unsaved))) return;
    reload();
  };
  return (
    <div role="status" data-testid="new-version-banner"
         className="fixed inset-x-0 top-0 z-[60] flex items-center justify-center gap-2 bg-emerald-700 px-4 py-1.5 text-xs text-white">
      <span>{L.msg}{" "}</span>
      <button type="button" onClick={onReload} className="rounded bg-white px-2 py-0.5 font-medium text-emerald-800" data-testid="new-version-reload">
        {L.reload}
      </button>
    </div>
  );
}
